import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_TRACKABLE_ITEMS, TrackableItemsState } from "./trackable-items.reducer";
import { ItemCategoryType } from "./trackable-item.types";

const trackableItemsState = (appState: any) => appState[STORE_FEATURE_KEY_TRACKABLE_ITEMS];
const itemCategorySelector = (trackableItemsState: TrackableItemsState) => trackableItemsState.itemCategories;
const itemTypesSelector = (trackableItemsState: TrackableItemsState) => trackableItemsState.itemTypes;
const statesSelector = (trackableItemsState: TrackableItemsState) => trackableItemsState.states;
const locationTypesSelector = (trackableItemsState: TrackableItemsState) => trackableItemsState.locationTypes;
const locationsSelector = (trackableItemsState: TrackableItemsState) => trackableItemsState.locations;

@Injectable()
export class TrackableItemsSelectors {
    constructor(private store: Store<any>) {
    }

  selectItemCategory(): Observable<Array<ItemCategoryType>> {
    return this.store
      .pipe(select(trackableItemsState), select(itemCategorySelector));
  }

  selectItemTypes(): Observable<Array<string>> {
      return this.store.pipe(select(trackableItemsState), select(itemTypesSelector));
  }

  selectStates(): Observable<Array<string>> {
      return this.store.pipe(select(trackableItemsState), select(statesSelector));
  }

  selectLocationTypes(): Observable<Array<string>> {
      return this.store.pipe(select(trackableItemsState), select(locationTypesSelector));
  }

  selectLocations(): Observable<Array<string>> {
      return this.store.pipe(select(trackableItemsState), select(locationsSelector))
  }
}
